<div class="content">
  <div class="description subtitle">
    @if (isGoal) {
      <p [innerHTML]="'AUTOMATIONS.EDITOR.TASKS.IF_ELSE_BRANCH.GOAL_DESCRIPTION' | translate"></p>
    } @else {
      {{ 'AUTOMATIONS.EDITOR.TASKS.IF_ELSE_BRANCH.DESCRIPTION' | translate }}
    }
  </div>
  <ng-container *ngIf="predecessorOutputParams$ | async as predecessorOutputParams; else loading">
    <!-- Allow multi branching for goals might be fine and if any of the branches is true then the goal is achieved, but is that considered another goal because it definitely shouldn't be called another "branch".
    Turning off multi branching for goals until we get feedback about it -->
    <automata-workflow-step-filter
      #workflowStepFilter
      [filterStep]="copyOfStep"
      [predecessorOutputParams]="predecessorOutputParams"
      [displayInternalFilters]="showInternalFilters$ | async"
      [allowMultiBranching]="!isGoal"
      [isGoal]="isGoal"
    ></automata-workflow-step-filter>
  </ng-container>
  <ng-template #loading>
    <div class="side-drawer-shimmer-container">
      <span class="selector stencil-shimmer"></span>
    </div>
  </ng-template>
</div>
